import {
  keys,
  transform,
} from 'lodash-es';

import type { ITreeItem } from '@components/tree/VTree/types';
import type { ITranslationsKeyMap } from '@modules/i18n/types';
import { isString } from '@utils/guards';

export default function prepareTranslationsList(
  localesHash: ITranslationsKeyMap | undefined,
  prevKey = '',
  result: ITreeItem[] = [],
): ITreeItem[] {
  if (!localesHash) {
    return [];
  }

  const sortedKeys = keys(localesHash).sort((a, b) => a.localeCompare(b, 'en'));
  const newValue = transform(
    sortedKeys,
    (acc, val) => {
      acc[val] = localesHash[val];
    },
    {} as ITranslationsKeyMap,
  );
  return transform(
    newValue,
    (transformResult, value, key) => {
      const newKey = prevKey === '' ? key : `${prevKey}.${key}`;
      if (isString(value)) {
        transformResult.push({ path: newKey, key: newKey, label: key });
      } else {
        const item = {
          path: newKey,
          key: newKey,
          label: key,
          children: [],
        };
        transformResult.push(item);
        return prepareTranslationsList(value, newKey, item.children);
      }

      return transformResult;
    },
    result,
  );
}
